import React, { PureComponent, Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { Loader, Image, Responsive } from 'semantic-ui-react'
import { connect } from 'react-redux'
import TeamActions from 'Redux/TeamRedux'
import ProjectActions from 'Redux/ProjectRedux'
import SelectionActions from 'Redux/SelectionRedux'
import { path } from 'ramda'
import MainProjects from './MainProjects'
import CollaboratorProjects from './CollaboratorProjects'
import SearchProjects from './SearchProjects'
import logo from 'Images/logo.png'
import styles from './SideBarLeftStyles';

class SideBarLeft extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      documentTitle: '',
      addingProject: null,
      sharedProjects: true,
      searchProjectKeyword: ''
    }
  }

  componentDidMount () {
    const projectId = path(['params', 'projectId'], this.props.match)
    this.requestProjects(projectId)
  }

  componentWillUnmount () {
  }

  requestProjects = (projectId) => {
    this.props.teamsListRequest(projectId)
    this.props.projectsListRequest()
  }

  handleItemClick = (project) => () => {
    this.setState({ documentTitle: project.title })
    this.props.selectionsSetData('activeProject', project)
    this.props.history.push('/projects/' + project.id)
  }

  onTeamClick = (team) => () => {
    this.props.selectionsToggleActiveTeam(team.id)
  }

  onAddProjectStart = (team) => (e) => {
    e.stopPropagation()
    this.setState({ addingProject: team.id })
    this.props.selectionsAddActiveTeam(team.id)
  }

  onAddProjectEnd = () => {
    this.setState({ addingProject: null })
  }

  onSharedProjectsClick = () => {
    this.setState({sharedProjects: !this.state.sharedProjects})
  }

  toggleSideBar = () => {
    this.props.selectionsToggleSidebar('left')
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{this.state.documentTitle} - Project</title>
        </Helmet>
        <Loader active={this.props.fetching} />
        <div className={styles.header}>
          <Responsive minWidth={992}>
            <div className={styles.logo}>
              <Image src={logo} alt='logo' width='30px' className={styles.logoImg}/>
            </div>
          </Responsive>
          <Responsive minWidth={320} maxWidth={991}>
            <div className={styles.logo} onClick={this.toggleSideBar}>
              <Image src={logo} alt='logo' width='30px' className={styles.logoImg}/>
            </div>
          </Responsive>
          <SearchProjects
            onChange={value => this.setState({searchProjectKeyword: value})} />
        </div>
        <MainProjects
          onAddProjectStart={this.onAddProjectStart}
          onAddProjectEnd={this.onAddProjectEnd}
          searchProjectKeyword={this.state.searchProjectKeyword}
          handleItemClick={this.handleItemClick}
          activeProject={this.props.activeProject}
          history={this.props.history}
          addingProject={this.state.addingProject}
          teams={this.props.teams} />
        <CollaboratorProjects
          handleItemClick={this.handleItemClick}
          searchProjectKeyword={this.state.searchProjectKeyword}
          activeProject={this.props.activeProject}
          collaboratorProjects={this.props.collaboratorProjects}/>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  teams: state.teams.listData,
  fetching: state.teams.listFetching,
  collaboratorProjects: state.projects.listData,
  activeTeams: state.selections.activeTeams,
  activeProject: state.selections.activeProject
})

const mapDispatchToProps = (dispatch) => ({
  teamsListRequest: (projectId) =>
    dispatch(TeamActions.teamsListRequest(projectId)),
  projectsListRequest: () => dispatch(ProjectActions.projectsListRequest()),
  selectionsSetData: (key, value) =>
    dispatch(SelectionActions.selectionsSetData(key, value)),
  selectionsToggleActiveTeam: (teamId) =>
    dispatch(SelectionActions.selectionsToggleActiveTeam(teamId)),
  selectionsAddActiveTeam: (teamId) =>
    dispatch(SelectionActions.selectionsAddActiveTeam(teamId)),
  selectionsToggleSidebar: (key) =>
    dispatch(SelectionActions.selectionsToggleSidebar(key))
})

export default connect(mapStateToProps, mapDispatchToProps)(SideBarLeft)



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/SideBarLeft.js